import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Button, Glyphicon,} from 'react-bootstrap';
import Select from 'react-select';

class PagingButtons extends React.Component {

  getMaxPage = () => {
    let maxPage = this.props.numberOfItems / this.props.maxPageItems.value;
    maxPage = Math.ceil(maxPage);
    return maxPage;
  }


  getNextButtonDisabled = () => { return this.props.activePage === this.getMaxPage(); }


  render() {

    let maxOptions = [];
    for(let i = 1; i <= 10; i++){
      maxOptions.push({value: i*5, label: i*5});
    }

    return (
      <Fragment>
        { this.props.numberOfItems> 5 &&
        <div className='flex-row'>
          <div className='flex-row m-auto' style={{width: 'fit-content', justifyContent: 'center'}}>
            <Button data-cy={'first-page-button'} onClick={() => this.props.changePage(1)}>
              <Glyphicon glyph={'backward'}/>
            </Button>
            <Button data-cy={'back-button'} disabled={this.props.activePage === 1}
                    onClick={() => this.props.changePage(this.props.activePage-1)}>
              <Glyphicon glyph={'triangle-left'}/>
            </Button>
            <h4 className="m2">{this.props.activePage}</h4>
            <Button data-cy={'forward-button'} disabled={this.getNextButtonDisabled()}
                    onClick={() => this.props.changePage(this.props.activePage+1)}>
              <Glyphicon glyph={'triangle-right'}/>
            </Button>
            <Button data-cy={'last-page-button'}
                    onClick={() => this.props.changePage(this.getMaxPage())}>
              <Glyphicon glyph={'forward'}/>
            </Button>
          </div>

          <div className={'pull-right flex-row mr0'}>
            <p className={'mr1 mb-auto mt-auto'} style={{whiteSpace: 'nowrap', textAlign: 'center'}}>Items per Page: </p>
            <Select
              className={'mr0'}
              style={{width: '75px'}}
              id="maxPageItems"
              value={this.props.maxPageItems}
              onChange={this.props.handleMaxItemsChange}
              options={maxOptions}
              searchable={false}
              clearable={false}
            />
          </div>
        </div>
        }
      </Fragment>
    );
  }
}

PagingButtons.propTypes = {
  activePage: PropTypes.number.isRequired,
  maxPageItems: PropTypes.object.isRequired,
  numberOfItems: PropTypes.number.isRequired,
  handleMaxItemsChange: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
};




export default PagingButtons;



// WEBPACK FOOTER //
// ./src/components/PagingButtons.js